import React from 'react';

const PushPin = () => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="push_pin" clipPath="url(#clip0_9579_16166)">
      <path
        id="Vector"
        d="M7.94911 4.06512L6.47597 5.53826C6.14599 5.86825 5.94859 6.28367 5.88672 6.71678L4.11895 4.94901C4.56384 4.88714 4.97337 4.68384 5.29746 4.35975L6.7706 2.88661L7.94911 4.06512ZM9.42225 4.35975L6.47597 1.41347C6.31393 1.25143 6.04876 1.25143 5.88672 1.41347C5.72467 1.57552 5.72467 1.84068 5.88672 2.00273L6.18135 2.29736L4.70821 3.7705C4.21913 4.25958 3.42952 4.25958 2.94044 3.7705L2.35118 4.35975L4.11011 6.11868L2.04772 8.18108L2.04772 8.77033L2.63697 8.77033L4.69937 6.70794L6.47597 8.48454L7.06523 7.89529C6.57615 7.4062 6.57615 6.6166 7.06523 6.12752L8.53837 4.65438L8.833 4.94901C8.99504 5.11105 9.26021 5.11105 9.42225 4.94901C9.5843 4.78696 9.5843 4.5218 9.42225 4.35975Z"
        fill="#00624F"
      />
    </g>
    <defs>
      <clipPath id="clip0_9579_16166">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(0 0.832031)"
        />
      </clipPath>
    </defs>
  </svg>
);

PushPin.displayName = 'PushPin';
export default PushPin;
